import {
    apiRequest,
    anakDetail
} from "../../../../../../services/adapters/kepegawaian/anakService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", anakDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository